import i18n from '@/i18n/config';
export var templateTypeMap = new Map([
    ['auth', i18n.t('pages.config_templates.tabs.auth.title')],
    ['port_logging', i18n.t('pages.config_templates.tabs.port_logging.title')],
    ['smf', i18n.t('pages.config_templates.tabs.smf.title')],
    ['users_groups', i18n.t('pages.config_templates.tabs.users_groups.title')],
    ['script', i18n.t('pages.config_templates.tabs.script.title')],
    ['nom', i18n.t('pages.config_templates.tabs.netops.title')],
]);
